import html2canvas from 'html2canvas';

const waitForImages = (root) => {
    const images = Array.from(root.querySelectorAll('img'));
    return Promise.all(
        images.map(
            (img) =>
                new Promise((resolve) => {
                    if (img.complete) {
                        resolve();
                        return;
                    }
                    img.onload = () => resolve();
                    img.onerror = () => resolve();
                }),
        ),
    );
};

const cloneElementForCapture = (element) => {
    const container = document.createElement('div');
    container.setAttribute('aria-hidden', 'true');
    container.style.position = 'fixed';
    container.style.left = '-10000px';
    container.style.top = '0';
    container.style.zIndex = '-1';
    container.style.overflow = 'visible';
    container.style.width = `${element.offsetWidth}px`;

    const clone = element.cloneNode(true);
    clone.style.width = `${element.offsetWidth}px`;
    container.appendChild(clone);
    document.body.appendChild(container);

    return { container, clone };
};

export const captureVoucherElement = async (element) => {
    const captureWidth = element.offsetWidth;
    const { container, clone } = cloneElementForCapture(element);

    try {
        await waitForImages(clone);
        const captureHeight = clone.scrollHeight || element.scrollHeight;

        return await html2canvas(clone, {
            scale: 3,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff',
            width: captureWidth,
            height: captureHeight,
            windowWidth: captureWidth,
            windowHeight: captureHeight,
            scrollX: 0,
            scrollY: 0,
        });
    } finally {
        document.body.removeChild(container);
    }
};

export const addCanvasToSinglePagePdf = (pdf, canvas, imgData) => {
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const widthScale = pageWidth / canvas.width;
    const heightScale = pageHeight / canvas.height;
    const scale = Math.min(widthScale, heightScale);

    const imgWidth = canvas.width * scale;
    const imgHeight = canvas.height * scale;
    const xOffset = Math.max(0, (pageWidth - imgWidth) / 2);

    pdf.addImage(imgData, 'PNG', xOffset, 0, imgWidth, imgHeight);
};
